
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleAvaliacaoGratuita = () => {
    window.open('https://wa.me/5531972176645?text=Olá! Gostaria de fazer uma avaliação gratuita do meu precatório. Podem me ajudar?', '_blank');
  };

  const handleComoFunciona = () => {
    document.getElementById('processo')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-start bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(240, 248, 255, 0.8) 100%), url('https://readdy.ai/api/search-image?query=Realistic%20elderly%20man%20in%20his%2060s%20positioned%20on%20the%20RIGHT%20SIDE%20of%20image%2C%20sitting%20at%20simple%20wooden%20desk%20in%20modest%20home%20office%2C%20natural%20daylight%20through%20window%2C%20authentic%20documentary%20photography%20style%2C%20real%20person%20not%20AI%20generated%2C%20simple%20clothing%20like%20cardigan%20or%20shirt%2C%20reading%20documents%20or%20papers%2C%20warm%20natural%20lighting%2C%20genuine%20candid%20moment%2C%20photojournalistic%20style%2C%20LEFT%20SIDE%20of%20image%20should%20be%20mostly%20empty%20white%20space%20or%20very%20blurred%20background%20to%20allow%20text%20overlay%2C%20composition%20with%20subject%20on%20right%20third%20of%20frame&width=1920&height=1080&seq=hero-elderly-right-side&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <div className="mb-4">
              <span className="inline-block bg-blue-900 text-white px-4 py-2 rounded-full text-sm font-medium uppercase tracking-wide">
                RECEBA IMEDIATAMENTE SEU PRECATÓRIO
              </span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Venda seu precatório com<br />
              <span className="text-green-600">segurança e tranquilidade</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-6 max-w-2xl leading-relaxed text-gray-800 font-medium" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Receba o dinheiro à vista no dia da assinatura no cartório.
            </p>
            
            <div className="mb-8 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg leading-relaxed text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                  Trabalhamos com os Fundos de Investimentos mais confiáveis e sólidos do segmento.
                </p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg leading-relaxed text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                  Você terá a melhor proposta do mercado e atendimento especializado.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="text-lg px-10 py-4 bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold"
                onClick={handleAvaliacaoGratuita}
              >
                <i className="ri-calculator-line mr-2"></i>
                FAZER AVALIAÇÃO GRATUITA
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="text-lg px-10 py-4 border-2 border-gray-700 text-gray-800 hover:bg-gray-700 hover:text-white hover:border-gray-700 font-semibold"
                onClick={handleComoFunciona}
              >
                <i className="ri-play-circle-line mr-2"></i>
                Como Funciona
              </Button>
            </div>
          </div>
          
          <div className="hidden lg:block">
            {/* Espaço para a imagem de fundo */}
          </div>
        </div>
      </div>
    </section>
  );
}
